/* ============================================================================
   CRYSTALE geo + language/currency switcher.
   Companion to snippets/lang-currency-switcher.liquid (replaces Langify).
   - Custom dropdown toggles (language / currency).
   - Persists manual choices in the "crystale_geo_pref" cookie.
   - Geo-detects NEW visitors exactly once (no cookie) via free no-key IP
     JSON endpoints; redirects at most once per page load.
   - Restores the saved preference for RETURNING visitors (single redirect
     only when the saved preference differs from the current context).
   - Skipped entirely in the theme editor (Shopify.designMode).
   ============================================================================ */
(function () {
  'use strict';

  /* Never run inside the theme editor / customizer. */
  if (window.Shopify && window.Shopify.designMode) return;

  var COOKIE_NAME = 'crystale_geo_pref';
  var root = document.querySelector('[data-crystale-switcher]');
  if (!root) return;

  var currentLang = root.getAttribute('data-current-lang');
  var currentCountry = root.getAttribute('data-current-country');
  var langUrls = {
    'en': root.getAttribute('data-lang-url-en'),
    'zh-hant': root.getAttribute('data-lang-url-zh-hant'),
    'zh-hans': root.getAttribute('data-lang-url-zh-hans')
  };
  var availableCountries = (root.getAttribute('data-available-countries') || '').split(',').filter(function (c) { return !!c; });

  /* ------------------------------- cookies ------------------------------- */
  function readCookie() {
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE_NAME + '=([^;]*)'));
      return m ? JSON.parse(decodeURIComponent(m[1])) : null;
    } catch (e) { return null; }
  }
  function writeCookie(pref) {
    try {
      var v = encodeURIComponent(JSON.stringify(pref));
      var exp = new Date(Date.now() + 365 * 864e5).toUTCString();
      document.cookie = COOKIE_NAME + '=' + v + '; expires=' + exp + '; path=/; SameSite=Lax';
    } catch (e) { /* storage unavailable: continue without persistence */ }
  }

  /* ---------------------------- dropdown UI ---------------------------- */
  function closeAll(except) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-crystale-dropdown]'), function (dd) {
      if (dd === except) return;
      dd.classList.remove('open');
      var t = dd.querySelector('[data-crystale-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
      var m = dd.querySelector('[data-crystale-menu]');
      if (m) m.hidden = true;
    });
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-crystale-dropdown]'), function (dd) {
    var toggle = dd.querySelector('[data-crystale-toggle]');
    var menu = dd.querySelector('[data-crystale-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !dd.classList.contains('open');
      closeAll(dd);
      dd.classList.toggle('open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      menu.hidden = !willOpen;
    });
  });
  document.addEventListener('click', function () { closeAll(null); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  /* --------------------- country via localization form --------------------- */
  var form = document.getElementById('crystale-localization-form');
  var countryInput = document.getElementById('CrystaleCountryCode');

  function submitCountry(countryCode) {
    if (!form || !countryInput) return false;
    countryInput.value = countryCode;
    form.submit();
    return true;
  }

  /* Silent (no visible navigation) country update: POSTs the standard
     Shopify localization form via fetch, then calls `done`. Used to apply
     a country before a language redirect, keeping to one navigation. */
  function postCountrySilently(countryCode, done) {
    var finished = false;
    function finish() { if (!finished) { finished = true; done(); } }
    if (!form) { finish(); return; }
    try {
      var data = new FormData(form);
      data.set('country_code', countryCode);
      fetch(form.action, {
        method: 'POST',
        body: new URLSearchParams(data),
        credentials: 'same-origin',
        redirect: 'manual'
      }).then(finish, finish);
      setTimeout(finish, 4000);
    } catch (e) { finish(); }
  }

  /* ---------------------------- manual changes ---------------------------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-crystale-lang]'), function (a) {
    a.addEventListener('click', function () {
      writeCookie({ lang: a.getAttribute('data-crystale-lang'), country: currentCountry });
    });
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-crystale-country]'), function (btn) {
    btn.addEventListener('click', function () {
      var cc = btn.getAttribute('data-crystale-country');
      writeCookie({ lang: currentLang, country: cc });
      closeAll(null);
      submitCountry(cc);
    });
  });

  /* ------------------------- geo country mapping ------------------------- */
  /* Visitor country -> { language, representative country (drives currency) }.
     Exact mapping: HK zh-hant/HKD; MO zh-hant/USD; TW zh-hant/TWD;
     CN zh-hans/USD; GB en/GBP; US en/USD; AU en/AUD; CA en/CAD; SG en/SGD;
     MY en/MYR; JP en/JPY; KR en/KRW; AE en/AED; EU/EEA en/EUR; else en/USD. */
  var GEO_TABLE = {
    'HK': { lang: 'zh-hant', country: 'HK' },
    'MO': { lang: 'zh-hant', country: 'US' },
    'TW': { lang: 'zh-hant', country: 'TW' },
    'CN': { lang: 'zh-hans', country: 'US' },
    'GB': { lang: 'en', country: 'GB' },
    'US': { lang: 'en', country: 'US' },
    'AU': { lang: 'en', country: 'AU' },
    'CA': { lang: 'en', country: 'CA' },
    'SG': { lang: 'en', country: 'SG' },
    'MY': { lang: 'en', country: 'MY' },
    'JP': { lang: 'en', country: 'JP' },
    'KR': { lang: 'en', country: 'KR' },
    'AE': { lang: 'en', country: 'AE' }
  };
  /* EU/EEA (+ Switzerland) -> English + EUR (Germany as representative). */
  var EURO_ZONE = ['DE', 'FR', 'IT', 'ES', 'NL', 'BE', 'AT', 'IE', 'PT', 'FI', 'GR',
                   'SE', 'DK', 'NO', 'CH', 'PL', 'CZ', 'HU', 'SK', 'SI', 'EE', 'LV',
                   'LT', 'HR', 'RO', 'BG', 'LU', 'MT', 'CY', 'IS', 'LI'];

  function targetForCountry(cc) {
    if (GEO_TABLE[cc]) return GEO_TABLE[cc];
    if (EURO_ZONE.indexOf(cc) !== -1) return { lang: 'en', country: 'DE' };
    return { lang: 'en', country: 'US' };
  }

  /* Applies a {lang, country} target with at most one visible navigation.
     The cookie is always written BEFORE any redirect (loop safety). */
  var navigated = false;
  function applyTarget(target) {
    if (navigated) return;
    var wantCountry = target.country;
    if (availableCountries.length && availableCountries.indexOf(wantCountry) === -1) {
      wantCountry = currentCountry;
    }
    var langDiffers = target.lang !== currentLang;
    var countryDiffers = wantCountry !== currentCountry;
    writeCookie({ lang: target.lang, country: wantCountry });
    if (!langDiffers && !countryDiffers) return;
    navigated = true;
    if (!langDiffers) {
      if (!submitCountry(wantCountry)) navigated = false;
      return;
    }
    var url = langUrls[target.lang];
    if (!url) { navigated = false; return; }
    if (countryDiffers) {
      postCountrySilently(wantCountry, function () { window.location.href = url; });
    } else {
      window.location.href = url;
    }
  }

  /* --------------------- new vs returning visitors --------------------- */
  var saved = readCookie();
  if (saved && saved.lang && saved.country) {
    var cswRestoreKey = 'csw_pref_restored';
  var cswAlreadyRestored = false;
  try { cswAlreadyRestored = !!(window.sessionStorage && sessionStorage.getItem(cswRestoreKey)); } catch (e) {}
  if (!cswAlreadyRestored) {
    try { if (window.sessionStorage) { sessionStorage.setItem(cswRestoreKey, '1'); } } catch (e) {}
    applyTarget({ lang: saved.lang, country: saved.country });
  }
    return;
  }

  /* NEW visitor (no cookie): geo-detect once. Any failure -> default. */
  function fetchJson(url, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var ctrl = null;
      try { ctrl = new AbortController(); } catch (e) { /* older browser */ }
      var timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        reject(new Error('timeout'));
      }, timeoutMs || 4500);
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function (j) { clearTimeout(timer); resolve(j); })
        .catch(function (e) { clearTimeout(timer); reject(e); });
    });
  }

  fetchJson('https://ipwho.is/', 4500)
    .catch(function () { return fetchJson('https://ipapi.co/json/', 4500); })
    .then(function (geo) {
      var raw = geo && (geo.country_code || geo.country);
      var cc = raw ? String(raw).toUpperCase() : '';
      if (!/^[A-Z]{2}$/.test(cc)) return;
      applyTarget(targetForCountry(cc));
    })
    .catch(function () { /* geo unavailable/blocked: keep default experience */ });
})();
